// src/config/app/widgetConfig.js
import React from 'react';
import HistoryIcon from '@mui/icons-material/History';
import TimerIcon from '@mui/icons-material/Timer';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import ScaleIcon from '@mui/icons-material/Scale';
import ScreenLockPortraitIcon from '@mui/icons-material/ScreenLockPortrait';
import ClockWidget from '@platform/core/src/components/widgets/ClockWidget';
import StopwatchWidget from '@platform/core/src/components/widgets/StopwatchWidget';
import TimerWidget from '@platform/core/src/components/widgets/TimerWidget';
import AudioControllerWidget from '@platform/core/src/components/widgets/AudioControllerWidget';
import WeightPlateWidget from '@platform/core/src/components/widgets/WeightPlateWidget';
import ScreenLockWidget from '@platform/core/src/components/widgets/ScreenLockWidget';
// NEW IMPORT
import TimeSinceLastActivityWidget from '../../components/widgets/TimeSinceLastActivityWidget';

export const widgetConfig = {
  clock: {
    id: 'clock',
    component: ClockWidget,
    icon: <AccessTimeIcon fontSize="small" />,
    title: 'Clock',
  },
  stopwatch: {
    id: 'stopwatch',
    component: StopwatchWidget,
    icon: <TimerIcon fontSize="small" />,
    title: 'Stopwatch',
  },
  timer: {
    id: 'timer',
    component: TimerWidget,
    icon: <AccessAlarmIcon fontSize="small" />,
    title: 'Timer',
  },
  audioController: {
    id: 'audioController',
    component: AudioControllerWidget,
    icon: <GraphicEqIcon fontSize="small" />,
    title: 'Audio Player',
  },
  weightCalculator: {
    id: 'weightCalculator',
    component: WeightPlateWidget,
    icon: <ScaleIcon fontSize="small" />,
    title: 'Weight Calculator',
  },
  screenLock: {
    id: 'screenLock',
    component: ScreenLockWidget,
    icon: <ScreenLockPortraitIcon fontSize="small" />,
    title: 'Keep Screen On',
  },
  // NEW WIDGET CONFIGURATION
  timeSinceLastActivity: {
    id: 'timeSinceLastActivity',
    component: TimeSinceLastActivityWidget,
    icon: <HistoryIcon fontSize="small" />,
    title: 'Last Activity',
  },
};